import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://9966261402656f9d055299da1ef84ff5@o1128170.ingest.us.sentry.io/4509135108833280',
  integrations: [],
});
